import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'ja',
    fallbackLng: 'ja',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    ns: ['common', 'home', 'services', 'register', 'admin', 'notFound'],
    defaultNS: 'common',
    detection: {
      // localStorage の preferredLanguage を最優先（LanguageSwitcher が書き込む）。
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'preferredLanguage',
      caches: ['localStorage'],
    },
  });

export default i18n;
